var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2933 9C17.2933 12.7942 13.9444 16 9.64663 16C5.3489 16 2 12.7942 2 9C2 5.20578 5.3489 2 9.64663 2C13.9444 2 17.2933 5.20578 17.2933 9Z",
    stroke: "url(#paint0_linear_836_19022)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8998 0.999987L19.7815 10.3125L10.4536 6.28502L18.8998 0.999987Z",
    fill: "#B3BEC7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_836_19022",
    x1: 4.24249,
    y1: 2.08083,
    x2: 11.2366,
    y2: 14.3265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3BEC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729067,
    stopColor: "#B3BEC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#2C4961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C4961"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.b4dba5c4ad7349c5880432b36099903a.svg";
export { ForwardRef as ReactComponent };